<template>
  <div class="props-group">
      <el-form-item label="启用搜索">
        <div>
          <el-checkbox v-model="component.properties.search"></el-checkbox>
        </div>
      </el-form-item>
      <el-form-item label="是否多选">
        <div>
          <el-checkbox v-model="component.properties.multiple"></el-checkbox>
        </div>
      </el-form-item>
  </div>
</template>

<script>
export default {
  name: 'attr-search-choose',
  props: [ 'component' ]
}
</script>



// WEBPACK FOOTER //
// src/components/form/componentAttr/search-choose.vue